interface MockVideo {
  id: string;
  title: string;
  type: "movie" | "tv";
  cover: string;
  banner?: string;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  director: string;
  actors: string[];
  episodes?: number;
  updatedAt: string;
  playCount: number;
  synopsis: string;
  tags: string[];
  featured?: boolean;
}

export const movies: MockVideo[] = [
  {
    id: "m1",
    title: "星际远征",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%2C%20deep%20space%20nebula%2C%20lone%20astronaut%20silhouette%2C%20dramatic%20blue%20and%20orange%20lighting%2C%20no%20text&width=400&height=600&seq=movie-cover-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=epic%20sci-fi%20cinematic%20wide%20banner%2C%20vast%20nebula%20and%20starship%2C%20deep%20blue%20and%20orange%20light%2C%20no%20text&width=1600&height=900&seq=banner-01&orientation=landscape",
    year: 2024,
    region: "美国",
    genres: ["科幻", "冒险"],
    rating: 8.7,
    director: "克里斯·诺兰",
    actors: ["李昂", "艾米莉亚·克拉克", "张子轩"],
    updatedAt: "2024-08-12",
    playCount: 9820000,
    synopsis: "在人类最后的深空基地，一支远征队穿越虫洞寻找新的家园。面对未知的引力风暴与失联的同伴，他们必须在宇宙尽头做出关于文明存续的抉择。",
    tags: ["太空", "硬核科幻", "团队冒险"],
    featured: true,
  },
  {
    id: "m2",
    title: "暗夜追凶",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=noir%20crime%20thriller%20movie%20poster%2C%20rainy%20city%20night%2C%20detective%20silhouette%2C%20moody%20dark%20tones%2C%20no%20text&width=400&height=600&seq=movie-cover-02&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    genres: ["犯罪", "悬疑"],
    rating: 8.2,
    director: "陈默",
    actors: ["王砚辉", "周冬", "刘奕"],
    updatedAt: "2024-09-03",
    playCount: 7640000,
    synopsis: "接连发生的离奇案件让整座城市陷入恐慌，一位被停职的老刑警重启卷宗，顺着雨夜里的蛛丝马迹，逐渐揭开一场跨越十年的复仇阴谋。",
    tags: ["悬疑", "警匪", "反转"],
  },
  {
    id: "m3",
    title: "山海奇缘",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=epic%20oriental%20fantasy%20animation%20poster%2C%20mythical%20mountains%20and%20clouds%2C%20glowing%20creatures%2C%20rich%20colors%2C%20no%20text&width=400&height=600&seq=movie-cover-03&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    genres: ["动画", "奇幻"],
    rating: 8.9,
    director: "徐一鸣",
    actors: ["田羽", "林晓", "赵然"],
    updatedAt: "2024-07-21",
    playCount: 6890000,
    synopsis: "少年为寻找失踪的师父踏入山海秘境，与传说中的异兽结伴同行。在瑰丽的东方幻想世界里，他逐渐明白守护与放手的真正含义。",
    tags: ["国漫", "神话", "治愈"],
  },
  {
    id: "m4",
    title: "都市迷航",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20movie%20poster%2C%20lone%20figure%20in%20neon%20city%20street%20at%20dusk%2C%20cinematic%2C%20no%20text&width=400&height=600&seq=movie-cover-04&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "爱情"],
    rating: 7.8,
    director: "苏晴",
    actors: ["高以宁", "郑宇", "许安"],
    updatedAt: "2024-09-18",
    playCount: 5230000,
    synopsis: "三个在深夜都市里迷失方向的年轻人，因为一次意外相遇。他们在霓虹与加班之间寻找出口，也在彼此的陪伴中重新找到生活的坐标。",
    tags: ["都市", "群像", "治愈"],
  },
  {
    id: "m5",
    title: "极速燃点",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=high%20octane%20action%20movie%20poster%2C%20sports%20car%20and%20explosion%2C%20dynamic%20motion%2C%20orange%20sparks%2C%20no%20text&width=400&height=600&seq=movie-cover-05&orientation=portrait",
    year: 2023,
    region: "香港",
    genres: ["动作", "赛车"],
    rating: 7.5,
    director: "林国栋",
    actors: ["陈伟", "吴子谦", "王嘉"],
    updatedAt: "2024-06-30",
    playCount: 8120000,
    synopsis: "退役车手为替兄弟洗清冤屈重返地下赛道，一场横跨港岛的车王之争就此点燃。速度背后，是赌上一切的兄弟情义与救赎。",
    tags: ["赛车", "燃", "兄弟情"],
  },
  {
    id: "m6",
    title: "时光信笺",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=romantic%20movie%20poster%2C%20couple%20silhouette%20under%20warm%20sunset%2C%20soft%20nostalgic%20tones%2C%20no%20text&width=400&height=600&seq=movie-cover-06&orientation=portrait",
    year: 2022,
    region: "韩国",
    genres: ["爱情", "剧情"],
    rating: 8.1,
    director: "金敏哲",
    actors: ["朴智勋", "韩素英"],
    updatedAt: "2024-05-14",
    playCount: 4470000,
    synopsis: "一封迟到十年的信，让两个早已走散的人重新想起那个夏天。在时间的长河里，有些喜欢从未真正说出口，却从未消失。",
    tags: ["纯爱", "书信", "怀念"],
  },
  {
    id: "m7",
    title: "沉默证词",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=suspense%20thriller%20poster%2C%20abandoned%20courtroom%2C%20single%20spotlight%2C%20cold%20tension%2C%20no%20text&width=400&height=600&seq=movie-cover-07&orientation=portrait",
    year: 2024,
    region: "英国",
    genres: ["悬疑", "剧情"],
    rating: 8.4,
    director: "艾德华·里斯",
    actors: ["奥利弗·格兰特", "苏菲·贝尔"],
    updatedAt: "2024-08-27",
    playCount: 3980000,
    synopsis: "一场看似尘埃落定的审判，因一位沉默证人的出现而彻底反转。真相在法庭的光影之间被反复推翻，信仰与正义迎来终极拷问。",
    tags: ["法庭", "烧脑", "反转"],
  },
  {
    id: "m8",
    title: "末日方舟",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=post%20apocalyptic%20movie%20poster%2C%20ruined%20city%20and%20giant%20ark%20ship%2C%20dust%20storm%2C%20dramatic%20sky%2C%20no%20text&width=400&height=600&seq=movie-cover-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20banner%20of%20post%20apocalyptic%20city%20with%20giant%20ark%20and%20dust%20storm%2C%20no%20text&width=1600&height=900&seq=banner-03&orientation=landscape",
    year: 2024,
    region: "美国",
    genres: ["科幻", "灾难"],
    rating: 8.0,
    director: "马克·杰弗逊",
    actors: ["丹尼尔·雷", "娜塔莎·李"],
    updatedAt: "2024-09-25",
    playCount: 8760000,
    synopsis: "当海水吞没最后一块陆地，人类把希望寄托在一艘巨型方舟之上。十万张船票背后，是秩序与人性在极限压力下的彻底暴露。",
    tags: ["末世", "灾难", "人性"],
    featured: true,
  },
  {
    id: "m9",
    title: "笑闹一家亲",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=warm%20family%20comedy%20poster%2C%20cheerful%20colorful%20living%20room%2C%20playful%20lighthearted%20mood%2C%20no%20text&width=400&height=600&seq=movie-cover-09&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    genres: ["喜剧", "家庭"],
    rating: 7.6,
    director: "何欢",
    actors: ["范大成", "李梅", "小宝"],
    updatedAt: "2024-04-09",
    playCount: 6120000,
    synopsis: "一个三代同堂的普通家庭，为了筹备奶奶的八十大寿闹出一连串啼笑皆非的乌龙。笑过之后，才懂平凡日子里的温暖最珍贵。",
    tags: ["合家欢", "爆笑", "温情"],
  },
  {
    id: "m10",
    title: "深海迷影",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=underwater%20thriller%20movie%20poster%2C%20deep%20ocean%20abyss%2C%20mysterious%20light%20beam%2C%20teal%20dark%20tones%2C%20no%20text&width=400&height=600&seq=movie-cover-10&orientation=portrait",
    year: 2022,
    region: "日本",
    genres: ["惊悚", "科幻"],
    rating: 7.9,
    director: "山田浩介",
    actors: ["佐藤健", "石原里美"],
    updatedAt: "2024-03-22",
    playCount: 5340000,
    synopsis: "深海科考队在一万米海沟发现不明光源，随着下潜的深入，船员的记忆开始出现异常。大海深处，似乎藏着不该被唤醒的东西。",
    tags: ["深海", "幽闭", "惊悚"],
  },
  {
    id: "m11",
    title: "长安旧梦",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=ancient%20chinese%20costume%20drama%20movie%20poster%2C%20grand%20palace%20lanterns%2C%20elegant%20silk%2C%20warm%20gold%20tones%2C%20no%20text&width=400&height=600&seq=movie-cover-11&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "剧情"],
    rating: 8.3,
    director: "顾清欢",
    actors: ["江晚舟", "沈砚", "柳絮"],
    updatedAt: "2024-07-10",
    playCount: 4910000,
    synopsis: "长安城最繁华的灯火之下，一位女官与一位将军的命运悄然交错。权谋与情义之间，他们用一生写下一段无人知晓的往事。",
    tags: ["古装", "权谋", "虐恋"],
  },
  {
    id: "m12",
    title: "幻境守护者",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20fantasy%20animation%20poster%2C%20magical%20guardian%20and%20glowing%20forest%2C%20painterly%2C%20no%20text&width=400&height=600&seq=movie-cover-12&orientation=portrait",
    year: 2024,
    region: "日本",
    genres: ["动画", "奇幻"],
    rating: 8.6,
    director: "宫本凛",
    actors: ["花泽香菜", "神木隆之介"],
    updatedAt: "2024-09-12",
    playCount: 7180000,
    synopsis: "在即将崩塌的幻境森林里，最后的守护者与一个迷路的少年相遇。他们必须在梦境消散之前，找回被遗忘的勇气与承诺。",
    tags: ["奇幻", "冒险", "成长"],
  },
];